<template>
 <div>
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="运单编号:" prop="wayNo">
                <el-input  placeholder="" v-model="searchFrom.wayNo"></el-input>
              </el-form-item>
               <el-form-item label="运单状态 :" prop="platformStatus">
              <el-select v-model="searchFrom.platformStatus" placeholder="请选择">
                <el-option v-for="val in ydzt" :label="val.name" :value="val.val" :key="val.val"></el-option>
              </el-select>
            </el-form-item>
              <el-form-item label="司机姓名:" prop="dirverName">
                <el-input  placeholder="" v-model="searchFrom.dirverName"></el-input>
              </el-form-item>
              <el-form-item label="车牌号:" prop="vhcNo">
                <el-input  placeholder="" v-model="searchFrom.vhcNo"></el-input>
              </el-form-item>
              <el-form-item label="审核状态:" prop="auditStatus">
                <el-select  v-model="searchFrom.auditStatus"   placeholder="请选择">
                   <el-option label="全部" value=""></el-option>
                   <el-option label="待审核" value="0"></el-option>
                  <el-option label="审核通过" value="1"></el-option>
                  <el-option label="审核驳回" value="2"></el-option>
                  <el-option label="不审核" value="3"></el-option>
                </el-select>
              </el-form-item>
                  <el-form-item label="接单时间:" prop="receivingTime">
                    <el-date-picker
                      v-model="searchFrom.receivingTime"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
                   <el-form-item label="装车时间:" prop="outTime">
                    <el-date-picker
                      v-model="searchFrom.outTime"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
                   <el-form-item label="到货时间:" prop="arrivalTime">
                    <el-date-picker
                      v-model="searchFrom.arrivalTime"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="验收时间:" prop="acceptanceTime">
                    <el-date-picker
                      v-model="searchFrom.acceptanceTime"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
            </div>
        </div>

       <div class="searchBtnBox">
         <el-form-item btnCode="006P00JB001" v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="submitFn">提交</el-button>
          </el-form-item> -->
       </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"
      class="table" height="100%" style="width: 100%" center border >
        <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
        <el-table-column label="操作"  width="160">
            <template slot-scope="scope">
              <div>
              <el-button type="text" size="mini" btnCode="006P00JB002"    v-if="(scope.row.platformStatus==2002||scope.row.platformStatus==2003)&&btnFlg[1]"  @click="lookGps(scope.row)">监控</el-button>
              <el-button type="text" size="mini" btnCode="006P00JB003"   v-if="(scope.row.platformStatus==2006||scope.row.platformStatus==2004||scope.row.platformStatus==2005)&&btnFlg[2]"
               @click="lookGps(scope.row)">轨迹</el-button>
              <el-button type="text" size="mini" btnCode="006P00JB004"    v-if="(scope.row.platformStatus!=2001&&scope.row.platformStatus!=2002)&&btnFlg[3]"  @click="pingzFn(scope.row)">凭证</el-button>
              <el-button type="text" size="mini"  btnCode="006P00JB005"   v-if="(scope.row.platformStatus>2002)&&btnFlg[4]"   @click="seeClick(scope.row)">合同</el-button>
              <el-button type="text" size="mini" @click="unUsual(scope.row)" v-show="scope.row.abnormalState==1">异常</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column label="运单编号" width="200">
          <template slot-scope="scope">
            <span style="color: #0e6eec;cursor: pointer;" @click="detailFn(scope.row)">{{scope.row.wayNo}}</span>
          </template>
        </el-table-column>
        <el-table-column property="auditStatus" label="审核状态" >
          <template scope="scope">
            <div>
                <span v-if="scope.row.auditStatus==0 || scope.row.auditStatus==3">{{[ "待审核", "审核通过", "审核驳回" ,"不审核"][scope.row.auditStatus]}}</span>
                <el-button type="text" size="mini" v-if="scope.row.auditStatus==1 || scope.row.auditStatus==2"  @click="recordClick(scope.row)">
                  <span style="color: #0e6eec;cursor: pointer;">{{[ "待审核", "审核通过", "审核驳回" ,"不审核"][scope.row.auditStatus]}}</span>
                </el-button>
             </div>
          </template>
        </el-table-column>
          <el-table-column  width="160" property="platformStatus" :formatter="statusFormat" label="运单状态"></el-table-column>
        <el-table-column property="weight" width="120" :formatter="emptyFn"  label="调度量"></el-table-column>
        <el-table-column property="loadingWeight" :formatter="emptyFn" width="120"  label="装车量"></el-table-column>
        <el-table-column property="valuation" width="120"  :formatter="emptyFn"   label="估值"></el-table-column>
        <el-table-column property="unloadingWeight" :formatter="emptyFn" width="120"  label="卸车量"></el-table-column>
        <el-table-column property="vhcNo" width="100"  :formatter="emptyFn" label="车牌号"></el-table-column>
        <el-table-column property="dirverName" width="100" :formatter="emptyFn"  label="司机姓名"></el-table-column>
         <el-table-column property="dirverMobile" width="160" :formatter="emptyFn"  label="联系电话"></el-table-column>
        <el-table-column prop="receivingTime" width="170"  :formatter="dateFormat"  label="接单时间"></el-table-column>
         <el-table-column prop="outTime" width="170" :formatter="dateFormat"  label="装车时间"></el-table-column>
        <el-table-column prop="arrivalTime" width="170" :formatter="dateFormat"  label="到货时间"></el-table-column>
         <el-table-column prop="acceptanceTime" width="170" :formatter="dateFormat"  label="验收时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
      <!-- 车辆监控-->
   <el-dialog  title="车辆监控"  :visible.sync="dialogVehM" width="1130px"  class="vehm" :fullscreen="true" :close-oni-click-modal="false" @close="closeMapDialog" :close-on-press-escape="false" center>
      <mapReal :map-data="mapData"  v-if="mapData.isShowMap==1"></mapReal>
      <maphistory :map-data="mapData" v-if="mapData.isShowMap==2"></maphistory>
   </el-dialog>
   <!-- 签收 -->
    <el-dialog  title="签收"  :visible.sync="dialogQS" width="400px"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true" :rules="rules" :model="QSFrom" ref="QSFrom" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <div class="inpBox">
              <el-form-item label="签收重量:" prop="signingWeight">
                <el-input  placeholder="" maxlength="11" v-number-input.float="0" v-model="QSFrom.signingWeight"></el-input>
              </el-form-item>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogQS = false">取 消</el-button>
        <el-button type="primary" @click="QSsave('QSFrom')">确 定</el-button>
      </span>
   </el-dialog>
     <!-- 运单详情 -->
    <el-dialog  title="运单详情"  :visible.sync="dialogXQ" width="1100px"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
        <el-form :inline="true" ref="XQFrom" enctype="multipart/form-data" :model="goodform"   class="demo-form-inline" label-width="110px" size="mini">
          <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-envelope iconFont" aria-hidden="true"></i>收发货信息</span>
            </h4>
            <div class="box1">
                <div class="item">
                 <div v-if="goodform.waytype==5">
                    <div class="box1T" style="color:#0e6eec"><i class="el-icon-location"></i>(发){{baseData.p_name}}</div>
                    <div class="box1B"><span>{{baseData.p_person}}</span><span>{{baseData.p_phone}}</span><span>{{goodform.deliverAddress}}</span></div>
                  </div>
                  <div v-if="goodform.waytype!=5">
                    <div class="box1T"><span style="color:#0e6eec">(发){{goodform.deliverCompany}}</span></div>
                    <div class="box1B"><span>{{goodform.deliverPerson}}</span><span>{{goodform.deliverPhone}}</span><span>{{goodform.deliverAddress}}</span></div>
                  </div>
                </div>
                <div class="item">
                  <div class="box1T" style="color:#F56C6C" > <i class="el-icon-location"></i>(收){{goodform.receivingCompany}}</div>
                  <div class="box1B"><span>{{goodform.receivingPerson}}</span><span>{{goodform.receivingPhone}}</span><span>{{goodform.receivingAddress}}</span></div>
                </div>
            </div>
             <hr>
          </div>
           <div class="addressBox">
            <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>货物信息</span>
              </h4>
              <div>
            <el-form-item label="货物类型:"  class="jiage" prop="productType">
              <span>{{goodform.productTypeName}}</span>
            </el-form-item>
            <el-form-item label="调度量:"  class="jiage" prop="weight">
              <span>{{goodform.weight}}</span><span class="">{{goodform.unitMeasurement}}</span>
            </el-form-item>
           <el-form-item label="装车量:"  class="jiage" prop="weight">
              <span>{{goodform.loadingWeight}}</span><span class="">{{goodform.unitMeasurement}}</span>
            </el-form-item>
            <el-form-item label="卸车量:"  class="jiage" prop="weight">
              <span>{{goodform.unloadingWeight}}</span><span class="">{{goodform.unitMeasurement}}</span>
            </el-form-item>
            </div>
            <hr>
          </div>
          <div class="addressBox" v-if="goodform.goodList">
            <h4 class="title">
                <span><i class="fa fa-bars iconFont" aria-hidden="true"></i>货物明细</span>
              </h4>
              <div>
                <el-table :data="goodform.goodList" ref="detailTable"    bordersize="mini" class="table" height="300"  style="width: 100%" center border >
                  <el-table-column type="index" width="55" label="序号"></el-table-column>
                  <el-table-column property="cargoBarcode" width="160"   label="捆包号"></el-table-column>
                  <el-table-column property="productName" :formatter="emptyFn" label="品名"></el-table-column>
                  <el-table-column property="brand" width="120" :formatter="emptyFn" label="牌号"></el-table-column>
                  <el-table-column property="specification" width="140" :formatter="emptyFn"  :show-overflow-tooltip="true" label="规格"></el-table-column>
                  <el-table-column property="model" width="120" label="材质"></el-table-column>
                  <el-table-column property="weight" width="100" label="重量(吨)"></el-table-column>
                  <el-table-column property="position" width="100"  :formatter="emptyFn" label="库位"></el-table-column>
              </el-table>
            </div>
            <hr>
          </div>
          <div class="addressBox">
            <h4 class="title">
                <span><i class="fa fa-truck iconFont" aria-hidden="true"></i>承运信息</span>
              </h4>
              <div>
            <el-form-item label="车牌号:"  class="jiage" prop="productType">
              <span>{{goodform.vhcNo}}</span>
            </el-form-item>
            <el-form-item label="司机姓名:"  class="jiage" prop="weight">
              <span>{{goodform.dirverName}}</span>
            </el-form-item>
           <el-form-item label="联系电话:"  class="jiage" prop="weight">
              <span>{{goodform.dirverMobile}}</span>
            </el-form-item>
            </div>
            <hr>
          </div>
           <div class="addressBox">
            <h4 class="title">
                <span><i class="fa fa-clock-o iconFont" aria-hidden="true"></i>时间记录</span>
              </h4>
              <div>
                <div>
                    <el-form-item label="发布时间:" prop="createTime">
                        <el-date-picker
                          v-model="goodform.createTime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="timestamp"
                          type="datetime"
                          :readonly="true"
                            placeholder=""
                        ></el-date-picker>
                  </el-form-item>
                    <el-form-item label="发布人:"  class="jiage" prop="createUserName">
                    <span>{{goodform.createUserName}}</span>
                  </el-form-item>
                </div>
                <div v-if="goodform.receivingTime">
                   <el-form-item label="接单时间:" prop="receivingTime">
                        <el-date-picker
                          v-model="goodform.receivingTime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="timestamp"
                          type="datetime"
                          :readonly="true"
                            placeholder=""
                        ></el-date-picker>
                  </el-form-item>
                </div>
                <div  v-if="goodform.outTime">
                   <el-form-item label="装车时间:" prop="outTime">
                        <el-date-picker
                          v-model="goodform.outTime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="timestamp"
                          type="datetime"
                          :readonly="true"
                            placeholder=""
                        ></el-date-picker>
                  </el-form-item>
                </div>
                <div  v-if="goodform.arrivalTime">
                   <el-form-item label="到货时间:" prop="arrivalTime">
                        <el-date-picker
                          v-model="goodform.arrivalTime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="timestamp"
                          type="datetime"
                          :readonly="true"
                            placeholder=""
                        ></el-date-picker>
                  </el-form-item>
                </div>
                <div  v-if="goodform.acceptanceTime">
                   <el-form-item label="验收时间:" prop="acceptanceTime">
                        <el-date-picker
                          v-model="goodform.acceptanceTime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="timestamp"
                          type="datetime"
                          :readonly="true"
                            placeholder=""
                        ></el-date-picker>
                  </el-form-item>
                </div>
                <div  v-if="goodform.signingTime">
                   <el-form-item label="签收时间:" prop="signingTime">
                        <el-date-picker
                          v-model="goodform.signingTime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="timestamp"
                          type="datetime"
                          :readonly="true"
                            placeholder=""
                        ></el-date-picker>
                  </el-form-item>
                </div>
                <div  v-if="goodform.evaluateTime">
                   <el-form-item label="评价时间:" prop="evaluateTime">
                        <el-date-picker
                          v-model="goodform.evaluateTime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="timestamp"
                          type="datetime"
                          :readonly="true"
                            placeholder=""
                        ></el-date-picker>
                  </el-form-item>
                </div>
            </div>
            <hr>
          </div>
          <div class="addressBox" v-if="goodform.isChangeCar==1">
            <h4 class="title">
                <span><i class="fa fa-truck iconFont" aria-hidden="true"></i>换车记录</span>
              </h4>
              <div>
            <div>
              <el-form-item label="原车牌号:"  class="jiage" prop="productType">
                <span>{{goodform.carLogList[0].vhcNo}}</span>
              </el-form-item>
              <el-form-item label="原司机姓名:"  class="jiage" prop="weight">
                <span>{{goodform.carLogList[0].driverName}}</span><span class=""></span>
              </el-form-item>
              <el-form-item label="原联系电话:"  class="jiage" prop="weight">
                <span>{{goodform.carLogList[0].dirverMobile}}</span><span class=""></span>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="现车牌号:"  class="jiage" prop="productType">
                <span>{{goodform.carLogList[0].currentVhcNo}}</span>
              </el-form-item>
              <el-form-item label="现司机姓名:"  class="jiage" prop="weight">
                <span>{{goodform.carLogList[0].currentDirverName}}</span><span class=""></span>
              </el-form-item>
              <el-form-item label="现联系电话:"  class="jiage" prop="weight">
                <span>{{goodform.carLogList[0].currentDirverMobile}}</span><span class=""></span>
              </el-form-item>
              <el-form-item label="换车时间:" prop="">
                        <el-date-picker
                          v-model="goodform.carLogList[0].endTime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="timestamp"
                          type="datetime"
                          :readonly="true"
                            placeholder=""
                        ></el-date-picker>
                  </el-form-item>
            </div>
            </div>
          </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogXQ = false">取 消</el-button>
      </span>
   </el-dialog>
   <!-- 凭证 -->
    <lookVoucher  :row-data="row" v-if="zujianFlag" @destroy="destroy"></lookVoucher>
     <!-- 审核记录 -->
    <shenheJilu  :row-data="row" v-if="shenheJiluFlag" @destroy="destroy"></shenheJilu>
    <!-- 异常记录 -->
    <UnUsual v-if="recordMark" :recordMark.sync="recordMark" :rowData='rowData'/>
</div>
</template>

<script>
// import axios from 'axios'
import { getBtn } from '@/utils/getButton'
import { captainList, wayListImgs, wayDetail, getContractPdfForBusinessNo } from '@/api/soc-customer'
import mapReal from '@/components/mapreal.vue'
import maphistory from '@/components/maphistory.vue'
import { emptyFn } from '@/utils/util'
import lookVoucher from '@/components/networkFreight/lookVoucher.vue'
import shenheJilu from '@/components/networkFreight/shenheJilu.vue'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      h: 500,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      dialogVehM: false,
      dialogQS: false,
      QSFrom: {},
      dialogSH: false,
      tableList: [],
      productTypes: [],
      total: 0,
      loading: false,
      mapData: '',
      zujianFlag: false, // 凭证
      shenheJiluFlag: false, // 审核记录
      dialogXQ: false,
      goodform: {},
      ydzt: [
        { val: '', name: '请选择' },
        { val: 2002, name: '已接单' },
        { val: 2003, name: '运输中' },
        { val: 2004, name: '待验收' },
        { val: 3000, name: '已验收' }

      ],
      rules: {
        signingWeight: [
          { required: true, message: '请输入签收重量', trigger: 'blur' }
        ]
      },
      btnFlg: [],
      btnIdArr: ['006P00JB001', '006P00JB002', '006P00JB003',
        '006P00JB004', '006P00JB005'],
      rowData: {},
      recordMark: false

    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/captainWayManage')
    this.getList(this.searchFrom)
  },

  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 异常
    unUsual (row) {
      this.rowData.wayNo = row.wayNo
      this.rowData.dirverName = row.dirverName
      this.rowData.dirverMobile = row.dirverMobile
      this.rowData.vhcNo = row.vhcNo
      this.rowData.id = row.id
      this.recordMark = true
    },
    // 点击合同详情进入-pdf显示页面
    seeClick (row) {
      const loading = this.$loading({
        lock: true,
        text: '正在加载...'
      })
      getContractPdfForBusinessNo({
        source: 3,
        businessNo: row.wayNo
      }).then((res) => {
        loading.close()
        if (res) {
          var tempwindow = window.open('_blank') // 先打开页面
          tempwindow.location = res // 后更改页面地址
        } else {
          this.$alert('暂无生成合同', '系统提示')
        }
        // this.$router.push({
        //   path: '/contractPdf', // 跳转的路径
        //   query: {
        //     path: res
        //   }
        // })
      }).catch((error) => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 运单详情
    detailFn (row) {
      this.dialogXQ = true
      wayDetail({ businessNo: row.wayNo }).then(res => {
        this.goodform = res
      })
    },

    // 凭证
    pingzFn (row) {
      this.row = row
      this.zujianFlag = true
    },
    // 审核记录
    recordClick (row) {
      this.row = row
      this.shenheJiluFlag = true
    },
    // 组件销毁
    destroy () {
      this.zujianFlag = false
      this.shenheJiluFlag = false
    },

    // 查看定位
    lookGps (row) {
      this.dialogVehM = true
      this.mapData = row
      if (this.mapData.platformStatus == 2001 || this.mapData.platformStatus == 2002 || this.mapData.platformStatus == 2003) {
        this.mapData.isShowMap = 1
      } else {
        this.mapData.isShowMap = 2
      }
      this.mapData.type = 3
    },
    // 地图模态框关闭
    closeMapDialog () {
      this.mapData.isShowMap = 0
    },
    // 选择数据
    selectGoods (selection) {
      this.weight = 0
      var that = this
      selection.forEach(item => {
        that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 获取货物列表
    getList (searchFrom) {
      this.loading = true
      captainList(searchFrom).then(res => {
        this.tableList = res.list
        this.loading = false
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    closeDialog () {
      if (this.$refs.HQform !== undefined) {
        this.$refs.HQform.resetFields()
      }
      if (this.$refs.THform !== undefined) {
        this.$refs.THform.resetFields()
      }
      if (this.$refs.HTfrom !== undefined) {
        this.$refs.HTfrom.resetFields()
      }
      this.pwdFrom = {}
      this.$refs.table.clearSelection()
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        noOrderStatus: '[1001,1002]',
        hopeReceivingDate: null,
        transportEndOperateDate: null,
        createTime: null
      }
    },

    // 状态格式化
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 2002:
          return '已接单'
        case 2003:
          return '运输中'
        case 2004:
          return '待验收'
        case 2005: case 2006:
          return '已验收'
      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str = t.getFullYear() + '-' + month + '-' + date + ' ' + hour + ':' + minutes + ':' + seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 时间格式化
    dateFormat1: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str = t.getFullYear() + '-' + month + '-' + date
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  },
  components: {
    mapReal,
    maphistory,
    lookVoucher,
    shenheJilu
  }
}
</script>

<style scoped lang='less'>
.searchBox{
  display: flex;
}
.searchBox .el-date-editor{
      width: 350px!important;
}
.gjhBox{
      flex-shrink: 0;
}
.gjhBox /deep/.el-textarea__inner{
  width:150px;
}

/deep/.el-input.is-disabled .el-input__inner{
    border: none;
    background-color: #dcedff;
    color: #606266;
}
.dialogtnBox{
  display: flex;
  justify-content: space-between;
  /deep/.el-form-item--mini.el-form-item{
        margin-bottom: 15px!important;
  }

}
.box1 span{
  margin-left: 10px;
  font-size: 12px;
}
.imgBox{
  margin: 22px 10px;
  ul{
    display: flex;
    padding-left: 0;
    li{
         width: 160px;
    height: 160px;
    list-style: none;
    margin-right: 10px;
      img{
        width:100%;
        height:100%
      }
    }
  }
}
.el-dialog__body .inpBox  /deep/.el-input__inner{
  border:none;
  padding: 0;
}
.hidden /deep/.el-upload--picture-card{
  display: none;
}

/deep/.el-input.is-disabled .el-input__inner{
  background: #fff;
}
/deep/.el-dialog__body .el-input__suffix, .el-dialog__body /deep/.el-input__icon{
   display: none;
 }
 .danwei{
   /deep/ .el-input__inner{
         width: 300px;
    overflow: auto;
   }
 }
.box1{
  display: flex;
  padding-left: 20px;
  .item{
    max-width: 48%;
    margin-left: 10px;
    font-size: 14px;
  }
  .box1T{
    margin-bottom: 10px;
    font-weight: bold;
  }
  .box1B{
    display: flex;
    flex-wrap: wrap;
    span{
      margin-right: 20px;
      line-height: 26px;
    }
  }
}
/deep/.el-dialog__body .el-date-editor .el-input__inner{
  border:none;
}
</style>
